import { forAll } from '@mindscreen/nodetypes/FrontendSrc/JavaScript/util';
import { Popup } from '@stst/Javascript/util/popup';

let dialogs = null;

const getDialogElement = (el) => {
    if (typeof el === 'string') {
        if (el.startsWith('.') || el.startsWith('#')) {
            el = document.querySelector(el);
        } else {
            el = document.getElementById(el);
        }
    }
    return el;
};

/**
 * @param {HTMLElement|string} el
 * @return {Popup|null}
 */
const getDialog = (el) => {
    el = getDialogElement(el);
    if (el) {
        if ('WeakMap' in window && (/** @type WeakMap */(dialogs)).has(el)) {
            return (/** @type {WeakMap<HTMLElement, Popup>} */(dialogs)).get(el);
        } else if (el.id && el.id in dialogs) {
            return dialogs[el.id];
        }
    }
    return null;
};

export const open = (el) => {
    el = getDialogElement(el);
    const dialog = getDialog(el);
    if (dialog) {
        dialog.open = true;
        el.parentElement.classList.add('dialog__wrapper--extended');
        document.querySelector('.page-wrapper').setAttribute('aria-hidden', 'true');
    }
};
export const close = (el) => {
    el = getDialogElement(el);
    const dialog = getDialog(el);
    if (dialog) {
        dialog.open = false;
        el.parentElement.classList.remove('dialog__wrapper--extended');
        document.querySelector('.page-wrapper').removeAttribute('aria-hidden');
    }
};

export const init = () => {
    // move .dialog__wrapper to enable aria-hiding the rest of the page
    forAll('.js-dialog', el => {
        document.body.append(el.parentElement);
    });

    // actual init
    let isMap = false;
    if ('WeakMap' in window) {
        dialogs = new WeakMap();
        isMap = true;
    } else {
        dialogs = {};
    }
    forAll('.js-dialog', el => {
        const d = new Popup(el, {
            expandedAttribute: 'dialog-aria-expanded',
        });
        if (isMap) {
            (/** @type WeakMap */(dialogs)).set(el, d);
        } else if (el.id) {
            dialogs[el.id] = d;
        }
        const closeButton = el.querySelector('[data-dialog-action="close"]');
        if (closeButton) {
            closeButton.addEventListener('click', () => close(el));
        }
    });
    forAll('.js-dialog-disclosure[data-for]', disclosure => {
        const target = disclosure.getAttribute('data-for');
        disclosure.addEventListener('click', (e) => {
            e.preventDefault();
            open(target);
        });
    });
};
